import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogDescription } from "./ui/dialog";
import { Button } from "./ui/button";
import { StarRating } from "./StarRating";
import ReviewsBlock from "./ReviewsBlock";
import { MessageSquare } from "lucide-react";

/**
 * Small "Reviews" trigger button that, when clicked, opens a dialog with the
 * full ReviewsBlock. Useful for embedding inside compact cards (e.g. doctor card)
 * without ballooning the card layout.
 */
export default function ReviewsDialog({ targetType, targetId, targetName, rating, dataTestIdBase = "reviews-dialog" }) {
    const [open, setOpen] = useState(false);
    return (
        <Dialog open={open} onOpenChange={setOpen}>
            <DialogTrigger asChild>
                <Button
                    variant="outline"
                    size="sm"
                    className="rounded-none border-stone-300 text-xs h-7 px-2 inline-flex items-center gap-1.5"
                    data-testid={`${dataTestIdBase}-${targetId}`}
                >
                    <MessageSquare className="w-3 h-3" />
                    {rating && rating.count > 0
                        ? <><StarRating value={rating.average} size={11} /><span className="text-stone-600 ml-1">{rating.count} review{rating.count === 1 ? "" : "s"}</span></>
                        : <span className="text-stone-600">Be the first to review</span>}
                </Button>
            </DialogTrigger>
            <DialogContent className="rounded-none max-w-2xl max-h-[80vh] overflow-y-auto">
                <DialogHeader>
                    <DialogTitle className="font-serif text-2xl">{targetName}</DialogTitle>
                    <DialogDescription className="text-xs text-stone-500">Reviews and ratings from verified users.</DialogDescription>
                </DialogHeader>
                <ReviewsBlock targetType={targetType} targetId={targetId} label="Doctor reviews" />
            </DialogContent>
        </Dialog>
    );
}
